import { useTranslation } from 'react-i18next';
import PencilIcon from 'components/atoms/icons/pencilIcon';

import s from './styles.module.scss';

import type { FC, ReactElement } from 'react';

interface PatientServiceRowProps {
  label: string;
  value?: string | ReactElement;
  onEdit?: () => void;
}

const PatientServiceRow: FC<PatientServiceRowProps> = ({
  label,
  value,
  onEdit,
}) => {
  const { t } = useTranslation();
  const dataCy = label.toLowerCase().split(' ').join('-');

  return (
    <div className={s.item}>
      <p className={s.label} data-cy={`${dataCy}-label`}>
        {label}:
      </p>
      <p className={s.value} data-cy={`${dataCy}-value`}>
        {value || t('labels.bannerNoData')}

        {onEdit && (
          <button onClick={onEdit}>
            <PencilIcon />
          </button>
        )}
      </p>
    </div>
  );
};
export default PatientServiceRow;
